import { Grid } from '@material-ui/core'
import { Link } from '@reach/router'
import { pointrMinimalLogo } from 'assets/images'
import React from 'react'
import { IProps } from './Interface'
import { useStyles } from './Styles'

const SideBar: React.FC<IProps> = ({ disableMenuItem }) => {
  const classes = useStyles({})

  return (
    <Grid container className={classes.root} justify={'center'} alignItems={'flex-start'}>
      {disableMenuItem['snapshot'] ? (
        <img id="sidebar-pointr-logo" className={classes.pointrLogo} src={pointrMinimalLogo} alt={'Pointr'} />
      ) : (
        <Link to="/snapshot">
          <img id="sidebar-pointr-logo" className={classes.pointrLogo} src={pointrMinimalLogo} alt={'Pointr'} />
        </Link>
      )}
    </Grid>
  )
}

export default SideBar
